import { useContext } from "react";

import { useRouter } from "next/router";

import Cookies from "js-cookie";
import { parseCookies } from "nookies";

import Analytics from "pages/[tenant]/cp/assets/Analytics";
import Cart from "pages/[tenant]/cp/assets/Cart";
import ChartBars from "pages/[tenant]/cp/assets/ChartBars";
import Cog from "pages/[tenant]/cp/assets/Cog";
import Grid from "pages/[tenant]/cp/assets/Grid";
import Money from "pages/[tenant]/cp/assets/Money";
import SearchCircleFilled from "pages/[tenant]/cp/assets/SearchCircleFilled";
import { Tool } from "pages/[tenant]/cp/assets/Tool";
import Trending from "pages/[tenant]/cp/assets/Trending";
import SideMenuOption from "pages/[tenant]/cp/components/SideMenu/components/SideMenuOption";
import { useFinanceContext } from "pages/[tenant]/cp/context/";
import { isPageActive } from "pages/[tenant]/cp/utils/isPageActive";

import AuthContext from "shared/providers/context/AuthContext";
import GlobalContext from "shared/providers/context/GlobalContext";
import { useFeature } from "shared/utils/hooks/useFeature";

import { ContainerSideMenu } from "./styles";

const SideMenu = () => {
  const router = useRouter();
  const { sectionFinance, useSectionFinance } = useFinanceContext();
  const { loggedUser } = useContext(AuthContext);
  const { state } = useContext(GlobalContext);
  const isMobileAppClient = state?.isMobileAppClient;
  const cookies = parseCookies();
  const cpLastPage = cookies.cpLastPage;
  const isReportsEnabled = useFeature("f_reports");
  const isPromoter = loggedUser?.promoter;

  const redirectCPFinancial = () => {
    const isSuperAdmin = loggedUser?.superadmin;
    const isCoProducer = loggedUser?.has_recipient;
    const isSystem = loggedUser?.id === 1;
    const isMaster = loggedUser?.id === 2;

    if (!isSuperAdmin && !isCoProducer) {
      router.push("/404");
    }

    if (isSystem || (isSuperAdmin && isCoProducer && !isMaster)) {
      useSectionFinance("extract");
      router.push("/cp");
      Cookies.set("cpLastPage", "extract");
      return;
    }

    const statementPage = isSuperAdmin || isMaster ? "master" : "personal";
    Cookies.set("statementPage", statementPage);
    router.push("/cp/statement");
  };

  const redirectCPVendas = () => {
    useSectionFinance("sales");
    Cookies.set("cpLastPage", "sales");
    router.push("/cp");
  };

  const redirectCPTransaction = () => {
    const isSuperAdmin = loggedUser?.superadmin;
    const isCoProducer = loggedUser?.has_recipient;
    const isSystem = loggedUser?.id === 1;
    const isMaster = loggedUser?.id === 2;

    if (!isSuperAdmin && !isCoProducer) {
      router.push("/404");
    }

    if (isSystem || (isSuperAdmin && isCoProducer && !isMaster)) {
      useSectionFinance("transactions");
      router.push("/cp");
      Cookies.set("cpLastPage", "transactions");
      return;
    }

    const transactionPage = isSuperAdmin || isMaster ? "master" : "personal";
    Cookies.set("transactionPage", transactionPage);
    router.push("/cp/transactions");
  };

  return (
    <ContainerSideMenu>
      {isPromoter ? (
        <>
          <SideMenuOption
            LeftIcont={Trending}
            title="Dashboard"
            onClick={() => router.push("/cp/analytics")}
            active={isPageActive("analytics")}
          />
          <SideMenuOption
            LeftIcont={Cart}
            title="Produtos"
            onClick={() => router.push("/cp/products")}
            active={isPageActive("products")}
          />
          <SideMenuOption
            LeftIcont={Money}
            title="Extratos e saques"
            onClick={redirectCPFinancial}
            active={isPageActive("statement")}
          />
          <SideMenuOption
            LeftIcont={Analytics}
            title="Transações"
            onClick={redirectCPTransaction}
            active={isPageActive("transactions")}
          />
          <SideMenuOption
            LeftIcont={SearchCircleFilled}
            title="Pixels de rastreamento"
            onClick={() => router.push("/cp/pixel")}
            active={isPageActive("pixel")}
          />
        </>
      ) : (
        <>
          <SideMenuOption
            LeftIcont={Grid}
            title="Billboard"
            onClick={() => router.push("/cp/billboard")}
            active={isPageActive("billboard")}
          />
          {!isMobileAppClient && (
            <>
              <SideMenuOption
                LeftIcont={Money}
                title="Financeiro"
                onClick={redirectCPFinancial}
                active={isPageActive("statement")}
              />

              <SideMenuOption
                LeftIcont={Analytics}
                title="Vendas"
                onClick={redirectCPVendas}
              />
            </>
          )}

          {isReportsEnabled && (
            <SideMenuOption
              LeftIcont={ChartBars}
              title="Relatórios"
              onClick={() => router.push("/cp/reports")}
            />
          )}

          <SideMenuOption
            LeftIcont={Grid}
            title="Grupos"
            onClick={() => router.push("/cp/groups")}
            active={isPageActive("groups")}
          />

          <SideMenuOption
            LeftIcont={Grid}
            title="Vídeos"
            onClick={() => router.push("/cp/videos")}
            active={isPageActive("videos")}
          />

          <SideMenuOption
            LeftIcont={Cog}
            title="Ferramentas"
            onClick={() => router.push("/cp/tools")}
            active={isPageActive("tools")}
          />

          <SideMenuOption
            LeftIcont={Tool}
            title="Menus"
            onClick={() => router.push("/cp/menus")}
            active={isPageActive("menus")}
          />
        </>
      )}
    </ContainerSideMenu>
  );
};

export default SideMenu;
